export type UserMessageSlashCommandParts = {
  command: string;
  rest: string;
};

const SLASH_COMMAND_PREFIX_PATTERN = /^(\/\S+)( .+)$/;

/**
 * 解析用户消息开头的 `/command 正文` 结构。
 * 仅当满足「/ + 非空字符串 + 空格 + 后续内容」时返回分段。
 */
export const parseUserMessageSlashCommand = (
  text: string,
): UserMessageSlashCommandParts | null => {
  const trimmed = text.trimStart();
  const match = trimmed.match(SLASH_COMMAND_PREFIX_PATTERN);
  if (!match) {
    return null;
  }

  return {
    command: match[1],
    rest: match[2],
  };
};
